<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('scoreAssessment.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('scoreAssessment.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click.prevent="() => (show_form = true)"
            >{{ $t('add_new') }}</ts-button
          >
        </div>
        <!-- form action -->
        <a-modal
          v-if="show_form"
          v-model="show_form"
          :title="$t('scoreAssessment.pageTitle')"
          :zIndex="1020"
          :footer="null"
          :maskClosable="false"
          width="400px"
          @cancel="onCancel"
        >
          <assessment-form-main
            @cancel="onCancel"
            @fetch="fetchData"
            :edit-data="edit_data"
          />
        </a-modal>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.assessment_level.sc_ass_level_name }}</td>
            <td>{{ record.main_program.acp_name_foreign }}</td>
            <td>{{ record.assessment_base.sc_ass_bases }}</td>
            <td class="ts-whitespace-no-wrap text-left">
              <a
                href="#"
                v-tooltip="$t('scoreAssessment.inputScoreAssessment')"
                class="mr-2 text-info"
                @click.prevent="onCreateSubComponent(record)"
              >
                <i class="far fa-list-alt"></i>
              </a>
              <a
                href="#"
                class="text-primary"
                v-if="!parseInt(record.component_details_count) > 0"
                v-tooltip="$t('edit')"
                @click.prevent="edit(record)"
              >
                <i class="fa fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import AssessmentFormMain from './components/form-create-assessment-main'
import { mapState } from 'vuex'

export default {
  name: 'scoreAssessment',
  components: {
    AssessmentFormMain
  },
  data() {
    return {
      loading: false,
      show_form: false,
      edit_data: {}
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('scoreAssessment', ['resources', 'pagination']),
    columns() {
      return [
        { name: this.$t('scoreAssessment.assessmentLevel') },
        { name: this.$t('scoreAssessment.mainProgram') },
        { name: this.$t('scoreAssessment.assessmentBase') },
        { name: this.$t('actions'), style: 'text-align:left; width:7%' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('scoreAssessment/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.edit_data.sc_setup_id = record.sc_setup_id
      this.edit_data.sc_ass_id = record.sc_ass_level_id
      this.edit_data.acp_id = record.acp_id
      this.edit_data.sc_bas_id = record.sc_bas_id
      this.show_form = true
    },
    onCancel() {
      this.show_form = false
      this.edit_data = {}
    },
    onCreateSubComponent(record) {
      this.$router.push({
        name: 'score-assessment-create',
        params: { id: record.sc_setup_id },
        query: {
          program_structure_id:
            record.component_details.length > 0
              ? record.component_details[0].program_structure_id
              : 0
        }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('scoreAssessment/RESET_STATE')
    next()
  }
}
</script>
